<template>
  <div class="content">
    <!-- start of left -->
    <div class="left-box back-color-fff" :class="isLeftOpen ? 'open': 'close'">
      <template v-if="isLeftOpen">
        <!-- <el-select
          size="mini"
          v-model="leftPage.tenantName"
          placeholder="搜索/选择公司名称"
          filterable
          clearable
          @change="searchLeftData"
        >
          <el-option
            v-for="item in tenantList"
            :key="item.sendTenantGuid"
            :label="item.sendTenantName"
            :value="item.sendTenantName"
          >
          </el-option>
        </el-select> -->
        
        <el-input size="mini"
          v-model.trim="leftPage.tenantName"
          placeholder="搜索公司名称"
          clearable
          @input="searchLeftData"
          @keyup.enter.native="searchLeftData"
        />

        <!-- 公司数据，可分页 -->
        <div class="left-box-list">
          <div class="left-total-box">共 {{ leftPage.totalRows }} 条数据</div>
          <div class="left-box-list-li">
            <div v-for="item in leftTenantList" :class="item.guid == tenantGuid ? 'active': ''" @click="selectTenant(item)">
              {{ item.tenantName }}
            </div>
          </div>
          <el-pagination
            v-if="leftPage.totalRows > 0"
            layout="prev, pager, next"
            :pager-count="3"
            @size-change="leftSizeChange"
            @current-change="leftCurrentChange"
            :current-page="leftPage.pageIndex"
            :page-size="leftPage.pageSize"
            :total="leftPage.totalRows"
          >
          </el-pagination>
        </div>
      </template>

      <!-- start of open-close icon -->
      <img :src="isLeftOpen ? require('@/assets/icon-left.png'): require('@/assets/icon-right.png')" @click="isLeftOpen = !isLeftOpen" />
      <!-- end of icon -->
    </div>
    <!-- end of open-close icon -->

    <!-- start of right -->
    <div class="right-box" :style="{width: isLeftOpen ? 'calc(100% - 200px - 1px)': 'calc(100% - 1px)'}" >
      <!-- start of search -->
      <div class="search-area">
        <div class="tenant-name">{{ tenantName }}</div>
        <el-row :gutter="24">
          <!-- 流程名称 -->
          <el-col :span="8">
            <div class="search-area-div">流程名称</div>
            <el-input size="mini" v-model="page.flowName" placeholder="请填写流程名称" class="ipt-sty" clearable />
          </el-col>
          <!-- <el-col :span="6">
            <div class="search-area-div">启用状态</div>
            <el-input size="mini" v-model="page.status" placeholder="请填写启用状态" class="ipt-sty" clearable />
          </el-col> -->
          <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="info" @click="getRightData()">搜索</el-button>
          </el-col>
        </el-row>
      </div>
      <!-- end of search -->
      
      <!-- start of content -->
      <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="button-area">
          <el-button size="mini" :disabled="tenantGuid ? false: true" type="info" @click="addData">新增流程</el-button>
        </div>
        
        <!-- start of lsit -->
        <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%">
          <!-- 序号 -->
          <el-table-column header-align="center" align="center" label="序号" width="56" fixed="left">
            <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <!-- 流程名称 -->
          <el-table-column header-align="center" align="left" prop="flowName" label="流程名称" fixed="left">
          </el-table-column>
          <!-- 操作人 -->
          <el-table-column header-align="center" align="left" prop="updateUserName" label="操作人">
            <template slot-scope="scope">
                {{ scope.row.updateUserName || '-' }}
              </template>
          </el-table-column>
          <!-- 操作时间 -->
          <el-table-column header-align="center" align="left" prop="updateTime" label="操作时间">
              <template slot-scope="scope">
                {{ scope.row.updateTime | getDate }}
              </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column header-align="center" align="center" width="280" prop="address" label="操作" fixed="right">
            <template slot-scope="scope">
              <a class="set-person" @click="toSet(scope.row.guid, scope.row.tenantGuid, scope.row.flowName, scope.row.tenantName)">规则设置｜</a>
              <a class="set-person" @click="toCopy(scope.row.tenantGuid, scope.row.flowName, scope.row.tenantName, scope.row.guid)">复制｜</a>
              <a class="set-person" @click="editData(scope.row)">编辑｜</a>
              <a class="set-person" @click="delData(scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <!-- end of lsit -->
        
        <!-- start of lsit -->
        <el-pagination
          class="back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
        <!-- end of pagination -->
        
      </div>
      <!-- end of lsit -->
      
    </div>
    <!-- end of right -->

    <!-- start of dialog-复制流程 -->
    <el-dialog title="复制流程" :visible.sync="dialogVisible" width="500px">
      <el-form label-width="140px" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">流程名称:</span>
          <div class="fl">{{ form.flowName }}</div>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">应用公司</span>
          <el-select class="fl" v-model="form.tenantGuid" placeholder="请选择" filterable multiple >
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid"
            >
            </el-option>
          </el-select>

        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="info" @click="addReqVersion">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-复制流程 -->

    <!-- start of dialog-新增|编辑 -->
    <el-dialog :title="isAdd ? '新增' : '编辑'" :visible.sync="editDialog" width="35%">
      <el-form
        ref="formData"
        label-width="140px" 
        :model="formData"
        :rules="formRules"
      >
        <el-form-item label="应用公司">
          <div class="fl">{{ tenantName }}</div>
        </el-form-item>
        <el-form-item label="流程编码" prop="flowType">
          <el-input size="small" :maxlength="5"  v-model="formData.flowType" placeholder="请填写流程编码" clearable />
        </el-form-item>
        <el-form-item label="流程名称" prop="flowName">
          <el-input size="small" :maxlength="10" v-model="formData.flowName" placeholder="请填写流程名称" clearable />
        </el-form-item>
        <el-form-item
         label="界面排序"
         prop="sortNumber"
         v-if="!isAdd"
         :required="!isAdd"
         :rules="[{
          required: true, message: '界面排序必填', trigger: 'blur'
         },{
          required: true, message: '界面排序必填', trigger: 'change'
         }]"
        >
          <el-input size="small" :maxlength="8" onkeyup="this.value = this.value.replace(/\D/g, '')" v-model="formData.sortNumber" placeholder="请填写界面排序" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="editDialog = false">取 消</el-button>
        <el-button size="mini" type="info" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-新增|编辑 -->

  </div>
</template>
<script>
export default {
  name: 'processSettings',
  data() {
    return {
      tableHeight: window.innerHeight - 283,
      isLeftOpen: true, // 控制左侧企业数据是否展开
      tableData: [],
      page: {
        pageIndex: 1,
        pageSize: 50,
        tenantGuid: '',
        flowName: ''
      },
      tenantList: [],
      form: {
        flowName: '',
        tenantGuid: [],
        tenantName: "",
        flowType: "",
      },
      dialogVisible: false,
      fullscreenLoading: false,
      copyGuid: '',

      leftPage: {
        pageIndex: 1,
        pageSize: 15,
        totalRows: 0,
        // queryAllServiceTenantFlag: true, // 是否查询所有的运营公司 true是 false否
        currentTenantGuid: localStorage.guid,
        tenantName: ''
      },

      editDialog: false,
      isAdd: true, // 是否是新增
      formData: {
        guid: '',
        tenantGuid: '',
        tenantName: '',
        flowType: '', // 流程编码
        flowName: '', // 流程名称
        sortNumber: '' // 排序
      },
      formRules: {
        flowType: [
          { required: true, message: '流程编码必填', trigger: 'blur' },
        ],
        flowName: [
          { required: true, message: '流程名称必填', trigger: 'blur' },
        ]
      },
      leftTenantList: [],
      tenantName: '', // 公司名称
      tenantGuid: '' // 公司guid
    }
  },
  created() {
    this.getTenantDz();
    
    if(sessionStorage.functionProcessSettings) {
      let datas = JSON.parse(sessionStorage.functionProcessSettings)
      this.leftPage['pageIndex'] = datas.leftPageIndex;
      this.tenantGuid = datas.tenantGuid;
      this.tenantName = datas.tenantName;
      this.page['pageSize'] = datas.pageSize;
      this.page['pageIndex'] = datas.pageIndex;
      this.isLeftOpen = datas.isLeftOpen;
      // 获取左侧列表内容
      this.getLeftData(false);
    }

    if(!sessionStorage.functionProcessSettings) {
      // 获取左侧列表内容
      this.getLeftData();
    }

  },
  methods: {
    searchLeftData() {
      this.leftPage['pageIndex'] = 1;
      this.leftPage['totalRows'] = 0;
      this.leftTenantList = [];

      this.page['pageIndex'] = 1;
      this.page['totalRows'] = 0;
      this.page['flowName'] = '';
      
      this.tableData = [];

      this.getLeftData();
    },
    /**
     * 获取左侧列表数据
     */
    getLeftData(flag = true) {
      let that = this;
      that.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants`, that.leftPage).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let { data } = res;
          if(data.data && data.data.records) {
            that.leftTenantList = data.data.records || [];
            that.leftPage.totalPage = data.data.totalPages;
            that.leftPage.totalRows =  data.data.totalRows;

            // 如果有数据
            if(data.data.records.length > 0) {
              if(flag) {

                that.tenantName = data.data.records[0].tenantName;
                that.tenantGuid = data.data.records[0].guid;
              }
              
              // 获取右侧列表内容
              that.getRightData();
            }
          }
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 左侧选择企业
     * @param {*} item 
     */
    selectTenant(item) {
      this.tenantGuid = item.guid;
      this.tenantName = item.tenantName;
      // 获取右侧列表内容
      this.getRightData();
    },
    /**
     * 左侧分页
     * @param {*} val 
     */
    leftSizeChange(val) {
      this.leftPage.pageSize = val;
      this.getLeftData();
    },
    /**
     * 左侧分页
     * @param {*} val 
     */
     leftCurrentChange(val) {
      this.leftPage.pageIndex = val;
      this.getLeftData();
    },
    // getTenantDz() {
    //   let self = this;
    //   let query = {
    //     pageIndex: 1,
    //     pageSize: -1,
    //     // queryAllServiceTenantFlag: true, // 是否查询所有的运营公司 true是 false否
    //     currentTenantGuid: localStorage.guid
    //   };
    //   self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants`, query).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.tenantList =  res.data.data.records || [];
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    //复制的公司，所有服务商所有药企
    getTenantDz() {
      let self = this;
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-service-and-tenant-list`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data|| [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 获取右侧数据
     */
    getRightData() {
      let self = this;
      this.page.tenantGuid = this.tenantGuid;
      self.api.postJson(`/${serverConfig.msConfigureService}/flow/data/flow-template-page-list`, this.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getRightData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.getRightData();
    },
    /**
     * 右侧添加
     */
     addData() {
      this.isAdd = true;
      this.editDialog = true;
      this.formData = {
        guid: '',
        tenantGuid: '',
        tenantName: '',
        flowType: '', // 流程编码
        flowName: '', // 流程名称
        sortNumber: '' // 排序
      };
      this.$nextTick(() => {
        this.$refs['formData'].resetFields()
      })
    },
    /**
     * 右侧编辑
     */
    editData(item) {
      this.isAdd = false;
      this.editDialog = true;
      this.formData = JSON.parse(JSON.stringify(item));
      this.$refs['formData'].resetFields()
    },
    /**
     * 右侧新增|编辑提交
     */
    submitForm() {
      let that = this;
      that.formData.tenantGuid = this.tenantGuid;
      that.formData.tenantName = this.tenantName;
      that.formData.serviceTenantGuid = localStorage.guid;
      that.$refs['formData'].validate((valid) => {
        if (valid) {
          that.api.postJson(`/${serverConfig.msConfigureService}/flow/data/edit`, that.formData).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.editDialog = false;
              // 新增、修改提示语判断
              if(that.isAdd) {
                that.$message.success('添加成功');
              }else {
                that.$message.success('编辑成功');
              }
              that.getRightData();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 右侧删除
     */
    delData(guid) {
      let that = this;
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.api.postJson(`/${serverConfig.msConfigureService}/flow/data/delete`, [guid])
        .then((res) => {
          if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
            that.$message.success('删除成功');
            that.getRightData();
          }else {
            that.$message.error(res.data.msg);
          }
        }) 
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    toSet(guid, tenantGuid, flowName, tenantName) {
      this.$router.push({
        path: "/ruleSetting",
        query: {
          flowTemplateGuid: guid,
          tenantGuid: tenantGuid,
          flowName: flowName,
          tenantName: tenantName,
          productGuid:this.$route.query.productGuid
        }
      })

      sessionStorage.setItem('functionProcessSettings', JSON.stringify({
        leftPageIndex: this.leftPage.pageIndex,
        tenantGuid: this.tenantGuid,
        tenantName: this.tenantName,
        pageSize: this.page.pageSize,
        pageIndex: this.page.pageIndex,
        isLeftOpen: this.isLeftOpen
      }));
      
    },
    toCopy(tenantGuid, flowName, tenantName, guid) {
      this.copyGuid = guid;
      this.form.tenantGuid = [];
      this.form.flowName = flowName;
      // this.form = {
      //   flowName,
      //   tenantGuid,
      //   tenantName,
      // }
      this.dialogVisible = true;

    },
    addReqVersion() {
      let self = this;
      let query = [];
      if(!this.form.tenantGuid.length){
        this.$message.error('请先选择药企');
        return 
      }
      this.tenantList.forEach(item => {
        this.form.tenantGuid.forEach(j=>{
          if (item.guid == j) {
            let obj = {
              guid:this.copyGuid,
              tenantGuid:j,
              tenantName:item.tenantName
            }
            query.push(obj);
          }
        })
      })
      // let req = {
      //   guid: this.copyGuid,
      //   flowName: this.form.flowName,
      //   tenantGuid: this.form.tenantGuid,
      //   tenantName: this.form.tenantName,
      // }
      // if (this.form.flowName == '会议任务申请') {
      //   req.flowType = "00001";
      // }
      // if (this.form.flowName == '线上会议执行2') {
      //   req.flowType = "00002";
      // }
      // if (this.form.flowName == '会议任务总结') {
      //   req.flowType = "00003";
      // }
      // if (this.form.flowName == '潜在客户信息申请4') {
      //   req.flowType = "00004";
      // }
      // if (this.form.flowName == '学术活动5') {
      //   req.flowType = "00005";
      // }
      // if (this.form.flowName == '新客户申请') {
      //   req.flowType = "00006";
      // }
      // if (this.form.flowName == '客户档案修改') {
      //   req.flowType = "00007";
      // }
      self.api.postJson(`/${serverConfig.msConfigureService}/flow/data/duplicateBatch`, query).then(res => {
        this.dialogVisible = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // self.getTenantDz();
          self.$confirm('复制成功，该企业人员可以看到此流程啦，请及时设置该流程的规则，以免影响使用！', '提示', {
            confirmButtonText: '好的，我知道了',
            showCancelButton: false,
            type: 'warning',
          })
            .then(() => {
              
            })
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

  },
}
</script>
<style lang="less" scoped>
.left-box, .right-box {
  float: left;
}

.left-box {
  width: 200px;
  height: calc(100vh - 60px - 30px);
  border-right: 1px solid #D9D9D9;
  position: relative;
  .el-input {
    width: calc(100% - 14px);
    margin: 10px auto 0px auto;
  }
  .left-box-list {
    text-align: left;
    .left-total-box {
      color: #999999;
      margin: 8px 10px;
      font-size: 12px;
    }
    .left-box-list-li {
      height: 70vh;
      overflow-y: auto;
      div {
        color: #666666;
        cursor: pointer;
        text-align: left;
        height: 32px;
        line-height: 32px;
        padding: 0px 10px;
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis; 
        &:hover {
          background-color: #EBF6F7;
          color: #4FA1A4;
        }
      }
      
      .active {
        background-color: #EBF6F7;
        color: #4FA1A4;
      }
    }
  }
  .el-pagination {
    position: absolute;
    bottom: 7px;
    z-index: 9;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background-color: #ffffff;
  }
  /deep/ .el-pagination .btn-prev, /deep/ .el-pagination .btn-next {
    padding: 0px;
    min-width: 25px;
  }
  /deep/ .el-pager li {
    min-width: 25px;
  }

  img {
    width: 24px;
    height: 58px;
    position: absolute;
    right: -5px;
    top: calc(50% - 29px);
    z-index: 99;
    cursor: pointer;
  }
}
.open {
  width: 200px;
  img {
    right: -5px;
    left: auto;
  }
}
.close {
  width: 0px;
  img {
    left: -5px;
    right: auto;
  }
}

.right-box {
  width: calc(100% - 200px - 1px);

  .content-main-box {
    height: calc(100vh - 60px - 36px - 56px - 30px);

    .set-person {
      color: #4FA1A4;
      text-decoration: none;
      cursor: pointer;
    }
  }
  .el-pagination {
    border-top: 1px solid #D9D9D9;
    padding: 8px 0px;
  }
  .tenant-name {
    margin: 0 0 12px 0;
    text-align: left;
    font-size: 16px;
    color: #323233;
  }
}
.content {
  display: flex;
}
</style>
